
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    registrationForScheduling: {
      type: Object,
      default: () => {},
    },
    idProduct: {
      type: String,
      default: () => '',
    },
  },
  data() {
    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(new Date().getDate() + 1)
    if (tomorrow.getDay() === 6 || tomorrow.getDay() === 0) {
      tomorrow.setDate(tomorrow.getDate() + (8 - tomorrow.getDay()))
    }

    return {
      datePicker: true,
      slotsShow: false,
      overlay: false,
      dialogConfirmScheduling: false,
      slotSelected: {},
      infoConfirmScheduling: {},
      loadingBtn: false,
      date: tomorrow.toISOString().substr(0, 10),
    }
  },
  computed: {
    ...mapGetters('sdagenda', ['allSlots', 'sdagenda']),
    ...mapGetters('dataClient', ['allCartClient']),
    ...mapGetters('agendamentos', ['allSlotsDay']),
    screenSlotsDate() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return '300'
      } else if (this.$vuetify.breakpoint.smOnly) {
        return '590'
      } else {
        return '790'
      }
    },
  },
  mounted() {
    this.verifysdagenda()
  },

  methods: {
    ...mapActions('sdagenda', ['scheduling', 'verifysdagenda']),
    ...mapActions('agendamentos', ['listSlotsDay']),
    ...mapActions('dataClient', ['cleanClient', 'cleanCartCient']),
    async listHorariosDisponiveis() {
      this.overlay = true
      try {
        const info = {
          date: this.date,
          idAgenda: this.sdagenda.id,
          ambiente: this.sdagenda.ambiente,
        }
        await this.listSlotsDay(info)
        this.datePicker = false
        this.slotsShow = true
      } catch (error) {
        this.$toast.error('error: ' + error)
      } finally {
        this.overlay = false
      }
    },
    datasPermitidas(dateString) {
      const ontem = new Date()
      ontem.setDate(ontem.getDate() - 1)
      const selectedDate = new Date(dateString)

      return (
        selectedDate >= ontem &&
        selectedDate.getDay() !== 5 &&
        selectedDate.getDay() !== 6
      )
    },
    slotsSelected(item) {
      this.slotSelected = item
      this.infoConfirmScheduling = {
        ...item,
      }
      this.dialogConfirmScheduling = true
    },
    async confirmScheduling() {
      this.loadingBtn = true
      try {
        const { valor, ...remainingObject } = this.registrationForScheduling
        const registrationForScheduling = {
          ...remainingObject,
          telefone: '+55 ' + this.registrationForScheduling.telefone,
          pagamento: {
            valor: this.formatarValorMonetario(
              this.registrationForScheduling.valor
            ),
          },
          produtoSelecionado: {
            nome: this.registrationForScheduling.produtoEmissao,
            sku: this.registrationForScheduling.sku,
          },
        }
        const agendaGeral = {
          _id: this.sdagenda.id,
          nome: this.sdagenda.nome,
          cor: this.sdagenda.cor,
        }
        const agendamento = {
          agenda: {
            ...agendaGeral,
          },
          cliente: {
            ...registrationForScheduling,
            cpfcnpj: registrationForScheduling.cpfCnpj,
            tipoSolicitacao: 'Novo Certificado',
            atendente: window.location.hostname,
            belongsTo: {
              name: '',
            },
            usuarioAgendamento: {
              name: 'Senha Digital',
              origem: window.location.hostname,
            },
          },
          dataHora: this.slotSelected.horario,
          status: 'NOVO',
        }

        await this.scheduling(agendamento)
        this.cleanClient()
        this.cleanCartCient(this.idProduct)
        if (this.allCartClient.length === 0) {
          this.$toast.success('AGENDAMENTO FEITO COM SUCESSO!!')
          this.$router.push('/')
        } else {
          this.$toast.success(
            'OK! Ainda há produtos disponíveis para agendamento.'
          )
        }
        this.$emit('action-more-agenda')
      } catch (error) {
        console.error(error)
        this.$toast.error('error: ' + error)
      } finally {
        this.loadingBtn = false
        this.dialogConfirmScheduling = false
        this.datePicker = true
        this.slotsShow = false
      }
    },
    returnDatePicker() {
      this.datePicker = true
      this.slotsShow = false
      this.toScroll()
    },
    toScroll() {
      const top = window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      return top
    },
    formatarValorMonetario(valor) {
      return valor.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
      })
    },
  },
}
